export default function interiorTabs() {
  const galleryTitles = document.querySelectorAll(".tab-gallery-title");
  const contentTitles = document.querySelectorAll(".tab-content-title");

  galleryTitles.forEach((title) => {
    title.addEventListener("click", function () {
      const link = title.getAttribute("href");

      const section = document.querySelector(
        `.tab-content-title[data-content="${link}"]`
      );

      section.click();
    });
  });

  contentTitles.forEach((title) => {
    title.addEventListener("click", function () {
      const link = title.getAttribute("href");

      const section = document.querySelector(
        `.tab-gallery-title[data-gallery="${link}"]`
      );

      section.click();
    });
  });
}
